import React from 'react';
import { Select } from 'antd';
import {
  AFTERPAYMENT,
  AFTERWARRENCY,
  DISABLED,
  display,
  IMMEDIATELY
} from 'constants/types';

const { Option } = Select;

const OrderSelectAutoIssueMode = ({
  hiddenOptions = [],
  nullOptionDescription,
  ...rest
}) => {
  const options = [
    { value: DISABLED, description: display[DISABLED] },
    { value: AFTERWARRENCY, description: display[AFTERWARRENCY] },
    { value: AFTERPAYMENT, description: display[AFTERPAYMENT] },
    { value: IMMEDIATELY, description: display[IMMEDIATELY] }
  ].filter((c) => !hiddenOptions.includes(c.value));

  if (nullOptionDescription) {
    options.unshift({ value: null, description: nullOptionDescription });
  }

  return (
    <Select {...rest}>
      {options.map((c) => (
        <Option key={c.value} value={c.value}>
          {c.description}
        </Option>
      ))}
    </Select>
  );
};

export default OrderSelectAutoIssueMode;

